import * as React from "react"
import Dialog from "@mui/material/Dialog"
import DialogActions from "@mui/material/DialogActions"
import DialogContent from "@mui/material/DialogContent"
import DialogTitle from "@mui/material/DialogTitle"
import { FormControl, IconButton, InputLabel, MenuItem, Select } from "@mui/material"
import CloseIcon from '@mui/icons-material/Close';
import Grid from "@mui/material/Grid2"
import { Button } from "@mui/material"

export default function SelectModal({
    open,
    closeModal,
    title = "Select",
    options,
    defaultOption = ""
}) {
    const [selectedOption, setSelectedOption] = React.useState(defaultOption)

    const submit = (e) => {
        e.preventDefault();
        closeModal && closeModal(selectedOption)
    }

    React.useEffect(() => {
        if (open) {
            setSelectedOption(defaultOption)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [defaultOption, open])

    return (
        <div>
            <Dialog
                open={open}
                onClose={() => closeModal && closeModal(false)}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                fullWidth
                maxWidth="sm"
            >
                <form onSubmit={submit}>
                    <DialogTitle>
                        <span style={{ "paddingRight": "24px" }}>{title}</span>
                        <IconButton
                            aria-label="close"
                            onClick={() => closeModal && closeModal(false)}
                            sx={{
                                position: 'absolute',
                                right: 8,
                                top: 8
                            }}
                        >
                            <CloseIcon />
                        </IconButton>
                    </DialogTitle>
                    <DialogContent sx={{ pt: .5 }}>
                        <FormControl fullWidth>
                            <InputLabel id="select-modal-select-label">Select</InputLabel>
                            <Select
                                labelId="select-modal-select-label"
                                id="select-modal-select"
                                value={selectedOption}
                                label="Select"
                                onChange={(e) => setSelectedOption(e.target.value)}
                            >
                                {options.map((option) =>
                                    <MenuItem key={option} value={option}>{option}</MenuItem>
                                )}
                            </Select>
                        </FormControl>
                    </DialogContent>
                    <DialogActions>
                        <Grid container justifyContent="space-between" sx={{ padding: "0px 30px 10px 30px", width: '100%' }}>
                            <Grid xs="auto">
                            </Grid>
                            <Grid xs="auto">
                                <Button variant="contained" type="submit" disabled={selectedOption === ""}>
                                    Submit
                                </Button>
                            </Grid>
                        </Grid>
                    </DialogActions>
                </form>
            </Dialog>
        </div>
    )
}
